/**
 * Get the locale from the HTML lang attribute
 *
 * @returns {string} The locale
 */
export const getLocale = () => {
  const htmlLang = document.documentElement.getAttribute('lang');
  if (!htmlLang) {
    console.warn('[ChatKit] No HTML lang attribute found, using default locale "en"');
    return 'en';
  }

  return htmlLang.split('-')[0].toLowerCase();
};
